import { ColumnSource, RowSource, Style } from '@omegagrid/grid';
import { getThemeManager } from "@omegagrid/core";
import { IndicatorResult } from '../../types';
import rp, { fixStyleForDarkMode } from '@reporting/rp-app-host';

function convertLegacyStyle(s: any, darkMode = false): Style {
	const style: Style = {};
	if (s['background-color']) style.fgColor = (s['background-color'] as string).replace('#', '');
	if (s['color']) style.color = (s['color'] as string).replace('#', '');
	if (s['font-weight']) style.bold = s['font-weight'] == 'bold';
	if (s['font-style']) style.italic = s['font-style'] == 'italic';
	if (s['border-color']) style.top = style.left = style.right = style.bottom = {
		style: 'thin',
		color: (s['border-color'] as string).replace('#', '')
	};

	// the legacy styles were always made for the light mode
	if (darkMode) fixStyleForDarkMode(style);

	return style;
}

function matchCondition(actualValue: number, condition: {condition: '=' | '>' | '<' | '>=' | '<=' | '!=' | '<>', value: number}) {
	const cmpValue = parseFloat(condition.value as any);
	switch (condition.condition) {
		case '=':
			return actualValue == cmpValue;
		case '>':
			return actualValue > cmpValue;
		case '<':
			return actualValue < cmpValue;
		case '>=':
			return actualValue >= cmpValue;
		case '<=':
			return actualValue <= cmpValue;
		case '!=':
		case '<>':
			return actualValue != cmpValue;
		default:
			return true;
	}
}

export function convertLegacyCellStyles(r: number, row: RowSource, textColumns: ColumnSource[], valueColumns: ColumnSource[], style: any): Record<number, Style> {
	const styles: Record<number, Style> = {};
	const darkMode = getThemeManager().activeTheme.type == 'dark';

	try {
		const s = JSON.parse(style);
		const rowStyles = s.row || [];
		const valueStyles = s.value || rowStyles;
		const varAbsStyles = [...(s.vara || []), ...(s.var_a || []), ...valueStyles];
		const varRelStyles = [...(s.varp || []), ...(s.var_p || []), ...varAbsStyles];

		if (rowStyles.length) {
			textColumns.forEach((col, c) => {
				const styleDef = rowStyles[0]?.style;
				if (styleDef) styles[c] = convertLegacyStyle(styleDef, darkMode);
			});
		}

		const offset = textColumns.length;
		valueColumns.forEach((col: any, c) => {
			const indicator = col._indicator as IndicatorResult;
			const isVar = indicator.dataColumn.startsWith('VAR_');
			const cellStyles = isVar ? (indicator.format?.endsWith('%') ? varRelStyles : varAbsStyles) : valueStyles;
			const index = c + offset;
			const value = parseInt(row.data[index]);
			for (const styleDef of cellStyles) {
				if (matchCondition(value, styleDef)) {
					styles[index] = convertLegacyStyle(styleDef.style, darkMode);
					break;
				}
			}
		});
	} catch (e) {
		rp.log.error(`Failed to parse style JSON for row ${JSON.stringify(row)}`);
	}

	return styles;
}
